export const levels = {
  debug: {
    colored: <i className="fas fa-bug live-show-console-level-debug" />,
    gray: <i className="fas fa-bug live-show-console-level-gray" />,
  },
  info: {
    colored: <i className="fas fa-info-circle live-show-console-level-info" />,
    gray: <i className="fas fa-info-circle live-show-console-level-gray" />,
  },
  error: {
    colored: <i className="fas fa-times live-show-console-level-error" />,
    gray: <i className="fas fa-times live-show-console-level-gray" />,
  },
  warn: {
    colored: <i className="fas fa-exclamation-circle live-show-console-level-warn" />,
    gray: <i className="fas fa-exclamation-circle live-show-console-level-gray" />,
  },
};
export const servers = {
  api_server: {
    colored: <span className="live-show-console-server live-show-console-server-api">API</span>,
    gray: <span className="live-show-console-server live-show-console-server-gray">API</span>,
  },
  live_server: {
    colored: <span className="live-show-console-server live-show-console-server-live">LIVE</span>,
    gray: <span className="live-show-console-server live-show-console-server-gray">LIVE</span>,
  },
};
